import { memo } from "react";
import { Badge } from "@/shared/components/ui/badge";
import type { RateType } from "../types/commission.types";

const RATE_TYPE_LABEL: Record<RateType, string> = {
  SUIT: "Terno",
  SHOES: "Sapato",
  GOWN: "Beca",
  GRADUATION: "Formatura",
};

const RATE_TYPE_CLASSES: Record<RateType, string> = {
  SUIT: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  SHOES: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  GOWN: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  GRADUATION: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
};

interface CommissionTypeBadgeProps {
  type: RateType;
}

/**
 * Badge visual para `RateType`. Exibe o rótulo em português e mantém
 * variantes consistentes em todas as telas que mostram comissões.
 *
 * @example
 * <CommissionTypeBadge type="SUIT" />
 */
export const CommissionTypeBadge = memo(function CommissionTypeBadge({
  type,
}: CommissionTypeBadgeProps) {
  return (
    <Badge variant="outline" className={RATE_TYPE_CLASSES[type]}>
      {RATE_TYPE_LABEL[type]}
    </Badge>
  );
});

export const RATE_TYPE_LABELS = RATE_TYPE_LABEL;
